import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ImageMessage from "components/ui/Layout/ImageMessage";

const AutoLogout: React.FC = () => {
  const [seconds, setSeconds] = useState<number>(10);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    if (seconds <= 0) {
      clearInterval(interval);
      navigate("/");
    }

    return () => clearInterval(interval);
  }, [seconds, navigate]);

  return (
    <ImageMessage
      title={`You will be automatically redirected to login page in ${seconds} seconds`}
      description={`Your company administrator has changed permissions associated with your profile. Please login again to continue accessing the portal.`}
    />
  );
};

export default AutoLogout;
